import { FETCH_LOCAL_IO_REQUEST, FETCH_LOCAL_IO_SUCCESS, FETCH_LOCAL_IO_FAILURE } from './types';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const localIOReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_LOCAL_IO_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_LOCAL_IO_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case FETCH_LOCAL_IO_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default localIOReducer;
